import React, { Fragment, useState } from 'react'
import { withRouter } from 'react-router-dom'

import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import estilos from './VerAnalisisFQComponent.module.css'
import DescriptionIcon from '@mui/icons-material/Description';
import { Edit } from '@mui/icons-material';

const VerFisicoQuimico = (props) => {

    const dispatch = useDispatch()

    const analisis = props.analisis;
    const documentos = props.documentos;
    const clienteSeleccionado = props.clienteSeleccionado;

    useEffect(() => {

    }, [])

    function convertirValor(value) {
        var match = value.match(/[0-9]+(\.[0-9]+)?/);
        if (match) {
            return parseFloat(match[0]);
        } else {
            return NaN; // Maneja casos en los que no se encuentren números
        }
    }

    function isInRange_35_55(value) {
        return convertirValor(value) >= 35 && convertirValor(value) <= 55;
    }

    function isInRange_100_400(value) {
        return convertirValor(value) >= 100 && convertirValor(value) <= 500;
    }

    function isInRange_0_10(value) {
        return convertirValor(value) >= 0 && convertirValor(value) <= 10;
    }

    function isInRange_30_300(value) {
        return convertirValor(value) >= 30 && convertirValor(value) <= 300;
    }

    function isInRange_0_5(value) {
        return convertirValor(value) >= 0 && convertirValor(value) <= 5;
    }

    function isInRange_0_40(value) {
        return convertirValor(value) >= 0 && convertirValor(value) <= 40;
    }

    function isInRange_0_0_5(value) {
        return convertirValor(value) >= 0 && convertirValor(value) <= 0.5;
    }

    function isInRange_0_0_5_alt(value) {
        return convertirValor(value) >= 0 && convertirValor(value) <= 0.5;
    }


    return (
        <Fragment>

            <div className='row'>
                <div className='row' class={`${estilos.labelVerde}`}>
                    Número de Análisis: <strong>{analisis.analisisfq}</strong>
                </div>

                <div className='mt-3' style={{ textAlign: 'left' }}>
                    <strong> ({clienteSeleccionado.numerosocio}) - {clienteSeleccionado.nombrerazonsocial}</strong>
                </div><br /><br />
                <div className='mt-3' style={{ textAlign: 'left' }}>
                    Inspector: <strong> ({analisis.inspector.titulo + " " + analisis.inspector.nombre + " " + analisis.inspector.apellidos})</strong>
                </div><br /><br />
                <div className='row' style={{ textAlign: 'left' }}>
                    <div className='col-4' >
                        Muestreo:<i></i> <br />
                        Folio: <i>{analisis.folio}</i><br />
                        Lote:  <i>{analisis.lote}</i><br />
                        Laboratorio: <i>{analisis.laboratorios.nombre}</i><br />
                    </div>
                    <div className='col-4'>
                        Categoría: <i>{analisis.categoriamezcal} </i><br />
                        Volumen:  <i>{analisis.volumen}</i><br />
                        Norma: <i>{analisis.norma}</i><br />
                        Estatus: <i>{analisis.cumple ? "CUMPLE" : "NO CUMPLE"}</i><br />
                        Clase: <i>{analisis.clase}</i><br />
                        {
                            analisis.clase == "Madurado en vidrio" ?
                                <Fragment>
                                    Años: <i>{analisis.anios}</i><br />
                                </Fragment>
                                :
                                analisis.clase == "Reposado" ?
                                    <Fragment>
                                        Meses: <i>{analisis.meses}</i><br />
                                    </Fragment>
                                    :
                                    analisis.clase == "Añejo" ?
                                        <Fragment>
                                            Años: <i>{analisis.anios}</i><br />
                                        </Fragment>
                                        :
                                        analisis.clase == "Abocado con" ?
                                            <Fragment>
                                                Ingrediente: <i>{analisis.ingrediente}</i><br />
                                            </Fragment>
                                            :
                                            analisis.clase == "Destilado con" ?
                                                <Fragment>
                                                    Ingrediente: <i>{analisis.ingrediente}</i><br />
                                                </Fragment>
                                                :
                                                <Fragment></Fragment>

                        }
                    </div>
                    <div className='col-4' style={{ textAlign: 'center' }}>
                        Editar Analisis<br />
                        <button className='btn btn-warning' onClick={() => { props.abrirActualizar() }}><Edit style={{ zoom: '1.5' }}></Edit></button><br />
                        {/* <p style={{ fontSize: '16px' }}>Documento solo visible con conexión a internet.</p> */}
                    </div>
                    {/* <div className='col-4' style={{ textAlign: 'center' }}>
                        Descargar Archivo<br />
                        <DescriptionIcon style={{ zoom: '3' }}></DescriptionIcon><br />
                        <p style={{ fontSize: '16px' }}>Documento solo visible con conexión a internet.</p>
                    </div> */}
                </div>

                <table className={`table ${estilos.tabla}`}>

                    <thead>
                        <tr>
                            <td>Parametro</td>
                            <td>Resultado</td>
                            <td>Rango Permisible</td>
                            <td>Calificación</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>% Alc. Vol. 20° C</td>
                            <td>{analisis.columenalcohol}</td>
                            <td>35 - 55</td>
                            <td style={{ backgroundColor: isInRange_35_55(analisis.columenalcohol) ? 'LightGreen' : 'LightCoral' }}>{isInRange_35_55(analisis.columenalcohol) ? 'Dentro del Rango' : 'Fuera del Rango'}</td>
                        </tr>
                        <tr>
                            <td>Alc. Sup.</td>
                            <td>{analisis.alcoholessuperiores}</td>
                            <td>100 - 400</td>
                            <td style={{ backgroundColor: isInRange_100_400(analisis.alcoholessuperiores) ? 'LightGreen' : 'LightCoral' }}>{isInRange_100_400(analisis.alcoholessuperiores) ? 'Dentro del Rango' : 'Fuera del Rango'}</td>
                        </tr>
                        <tr>
                            <td>Extracto Seco</td>
                            <td>{analisis.estractoseco}</td>
                            <td>0 - 10</td>
                            <td style={{ backgroundColor: isInRange_0_10(analisis.estractoseco) ? 'LightGreen' : 'LightCoral' }}>{isInRange_0_10(analisis.estractoseco) ? 'Dentro del Rango' : 'Fuera del Rango'}</td>
                        </tr>
                        <tr>
                            <td>Metanol</td>
                            <td>{analisis.metanol}</td>
                            <td>30 - 300</td>
                            <td style={{ backgroundColor: isInRange_30_300(analisis.metanol) ? 'LightGreen' : 'LightCoral' }}>{isInRange_30_300(analisis.metanol) ? 'Dentro del Rango' : 'Fuera del Rango'}</td>
                        </tr>
                        <tr>
                            <td>Furfural</td>
                            <td>{analisis.furfural}</td>
                            <td>0 - 5 </td>
                            <td style={{ backgroundColor: isInRange_0_5(analisis.furfural) ? 'LightGreen' : 'LightCoral' }}>{isInRange_0_5(analisis.furfural) ? 'Dentro del Rango' : 'Fuera del Rango'}</td>
                        </tr>
                        <tr>
                            <td>Aldehidos</td>
                            <td>{analisis.aldehidos}</td>
                            <td>0 - 40</td>
                            <td style={{ backgroundColor: isInRange_0_40(analisis.aldehidos) ? 'LightGreen' : 'LightCoral' }}>{isInRange_0_40(analisis.aldehidos) ? 'Dentro del Rango' : 'Fuera del Rango'}</td>
                        </tr>
                        <tr>
                            <td>Plomo</td>
                            <td>{analisis.plomo}</td>
                            <td>0 - 0.5</td>
                            <td style={{ backgroundColor: isInRange_0_0_5(analisis.plomo) ? 'LightGreen' : 'LightCoral' }}>{isInRange_0_0_5(analisis.plomo) ? 'Dentro del Rango' : 'Fuera del Rango'}</td>
                        </tr>
                        <tr>
                            <td>Arsénico</td>
                            <td>{analisis.arsenico}</td>
                            <td>0 - 0.5</td>
                            <td style={{ backgroundColor: isInRange_0_0_5(analisis.arsenico) ? 'LightGreen' : 'LightCoral' }} >{isInRange_0_0_5(analisis.arsenico) ? 'Dentro del Rango' : 'Fuera del Rango'}</td>
                        </tr>
                    </tbody>
                </table>
                <hr />
            </div>
        </Fragment>
    )
}

export default withRouter(VerFisicoQuimico)